<template>
	<v-container grid-list-xl>
		<v-layout row wrap>
			<v-flex lg6>        
				<label class="blackLabel">Date From:</label>
				<date-picker style="width: 100% !important" v-model="objRfcFilters.startDate" lang="en"></date-picker>
			</v-flex>
			<v-flex lg6>
				<label class="blackLabel">Date To:</label>
				<date-picker style="width: 100% !important" v-model="objRfcFilters.endDate" lang="en"></date-picker>
			</v-flex>
			<v-flex lg6>			
					<label class="blackLabel">Originator:</label>
					<v-select :items="rfcOriginators" v-model="objRfcFilters.originator" item-value="id" label="Select Originator" autocomplete solo></v-select>
			</v-flex>
			<v-flex lg6>
				<label class="blackLabel">Customer:</label>
				<v-select :items="rfcCustomers" v-model="objRfcFilters.customer" item-value="id" label="Select Customer" autocomplete solo></v-select>
			</v-flex>
			<v-flex lg6>
				<label class="blackLabel">Status:</label>
				<v-select v-model="objRfcFilters.status" :items="rfcStatusses" item-value="id" label="Select Status" autocomplete solo></v-select>
			</v-flex>
			<v-flex lg6>
				<label class="blackLabel">SR Number:</label>
				<v-text-field v-model="objRfcFilters.srNumber" label="Sr Number" solo></v-text-field>
			</v-flex>
			<v-flex lg6>
				<label class="blackLabel">CN Number:</label>
				<v-text-field v-model="objRfcFilters.cnNumber" label="CN Number" solo></v-text-field>
			</v-flex>
			<v-flex lg6>
				<label class="blackLabel">RFC Number:</label>
				<v-text-field v-model="objRfcFilters.rfcNumber" label="RFC Number" solo></v-text-field>
			</v-flex>
			<div class="pl-4 pr-1 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
					<!--<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>-->
					<v-btn color="success" class="text-xs-right" @click.stop="fncClearFilters()">Clear Filters</v-btn>
					<v-btn color="success" class="text-xs-right" @click.stop="fncGenerateRfcReport()">Generate</v-btn>
				</div>	
			</div>		
			<v-flex lg12 class="requiredMessage">
				&nbsp;
			</v-flex>			
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	import draggable from 'vuedraggable'
	import DatePicker from 'vue2-datepicker'
	export default {
	  name: 'Settings',
	  data () {
			return {
                startDate: window.localStorage.rfcStartDate,
				endDate: window.localStorage.rfcEndDate,
                originator: window.localStorage.rfcOriginator,
                customer: window.localStorage.rfcCustomer,
                status: window.localStorage.rfcStatus,
                srNumber: window.localStorage.rfcSrNumber,
                cnNumber: window.localStorage.rfcCnNumber,
                rfcNumber: window.localStorage.rfcRfcNumber
			};
		},		
		methods: {			
			fncActivate(objActive) {
				this.$store.commit('fncActivate', objActive);				
			},
			fncDeactivate(objActive) {
				this.$store.commit('fncDeactivate', objActive);				
			},
			fncHideModal () {
				this.$store.commit('hideModal');
			},
			fncGenerateRfcReport() {
			    this.$store.dispatch({
					type: 'fncFilterRfc',
					objFilters: this.objRfcFilters					
				})
                this.$store.commit('hideModal');
            },
			fncClearFilters() {
				/*localStorage.setItem('rfcStartDate', '');
				localStorage.setItem('rfcEndDate', '');
				localStorage.setItem('rfcOriginator', '');
				localStorage.setItem('rfcCustomer', '');
				localStorage.setItem('rfcStatus', '');
				localStorage.setItem('rfcSrNumber', '');
				localStorage.setItem('rfcCnNumber', '');
				localStorage.setItem('rfcRfcNumber', '');*/
				this.objRfcFilters.startDate = '';
				this.objRfcFilters.endDate = '';
				this.objRfcFilters.originator = '';
				this.objRfcFilters.customer = '';
				this.objRfcFilters.status = '';
				this.objRfcFilters.srNumber = '';
				this.objRfcFilters.cnNumber = '';
				this.objRfcFilters.rfcNumber = '';				
			}
		},
		computed: {
			...mapGetters([			
				'objAuthorize',				
				'globalModalParams',
				'rfcStatusses',
				'rfcOriginators',
				'rfcCustomers',
				'rfcSearchList',
				'rfcList',
				'objRfcFilters'
			])
		},
		created() {
		},
		components: {
			draggable,
			DatePicker
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>